import { defineComponent as _defineComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'DonationInfo',
  props: [
 "strings",
  "show_title",
  "top_title",
  "title",
  "tagline",
  "collected",
  "needed",
  "symbol",
  "show_progress",
  "show_collection",
  "thousand_separator",
  "decimal_separator",
  "number_decimals",
],
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const formatNumber = (value: any) => {
  const n = parseFloat(value);
  if (!isFinite(n)) return value;
  const decimals = Math.max(0, parseInt(String(props.number_decimals), 10) || 0);
  const parts = n.toFixed(decimals).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, props.thousand_separator || '');
  return parts.join(props.decimal_separator || '.');
};


const __returned__ = { props, formatNumber }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})